import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { CrossBoldIcon } from '@paygreen/paygreen-ui';
import 'react-toastify/dist/ReactToastify.css';

// we override css style with classes as props https://fkhadra.github.io/react-toastify/how-to-style#pass-css-classes-to-props
const StyledToastContainer = styled(ToastContainer).attrs({
    className: 'toast-container',
    toastClassName: 'toast',
    bodyClassName: 'body',
    progressClassName: 'progress-bar',
    closeButton: <CrossBoldIcon iconSize="xs" style={{ flexShrink: 0 }} />,
})`
    /* .toast-container */
    @media ${(props) => props.theme.screen.min.md} {
        width: ${(props) => props.theme.blockWidth.sm};
    }

    /* .toast is passed to toastClassName */
    .toast {
        background-color: ${(props) => props.theme.color.primary.light};
        color: ${(props) => props.theme.color.primary.main};
        font-family: 'Open Sans', sans-serif;
        font-size: ${(props) => props.theme.font.size.xs};

        @media ${(props) => props.theme.screen.min.md} {
            margin-right: ${(props) => props.theme.space.lg};
            margin-bottom: ${(props) => props.theme.space.md};
        }
    }

    button[aria-label='close'] {
        color: ${(props) => props.theme.color.primary.main};
        opacity: 1;
    }

    /* .body is passed to bodyClassName */
    .body {
    }

    /* .progress is passed to progressClassName */
    .progress-bar {
        background-image: linear-gradient(
            to right,
            ${(props) => props.theme.color.primary.gradientBase},
            ${(props) => props.theme.color.primary.gradientShade}
        );
    }
`;

const ToastNotification = () => (
    <StyledToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
    />
);

export default withTranslation('common')(ToastNotification);
